import { Link } from '@solidjs/meta';

export function WorkSans()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap' rel='stylesheet' />
	</>);
}

WorkSans.fontFamily = '"Work Sans", sans-serif';
